import { connect } from 'react-redux';

import { actionCreators, selectors } from 'dux/createInstance';
import { selectors as orgSelectors } from 'dux/org';
import { selectors as catalogSelectors } from 'dux/catalog';
import SummaryDrawer from './SummaryDrawer';

function mapStateToProps(state) {
  return {
    selectedService: selectors.selectedServiceSelector(state),
    // This feels a little hacky, but seemed better than writing a separate selector function
    // to see if the selected service is in beta
    isServiceBeta: selectors.isServiceBetaSelector(state, {
      serviceName: selectors.selectedServiceSelector(state),
    }),
    selectedVersion: selectors.selectedVersionSelector(state),
    selectedCloudProvider: selectors.selectedCloudProviderSelector(state),
    selectedCloudProviderIsBeta: selectors.selectedCloudProviderIsBetaSelector(state),
    selectedRegion: selectors.selectedRegionSelector(state),
    selectedFlavor: selectors.selectedFlavorSelector(state),
    selectedAddons: selectors.selectedAddonsSelector(state),
    selectedPlan: selectors.selectedPlanSelector(state),
    selectedCidr: selectors.selectedCidrSelector(state),
    enteredName: selectors.enteredNameSelector(state),
    supportLevelName: orgSelectors.getOrgState(state).supportLevelName,
    availableAddons: selectors.availableAddonsSelector(state),
    availablePlans: selectors.availablePlansSelector(state),
    regionsCatalog: catalogSelectors.getRegionsState(state),
    price: selectors.getCreateInstanceState(state).price,
    planInfoString: selectors.planInfoStringSelector(state),
    nodeInfoString: selectors.nodeInfoStringSelector(state),
    isFastlaneCustomer: orgSelectors.isFastlaneCustomerSelector(state),
  };
}

const mapDispatchToProps = {
  getPrice: actionCreators.getPrice,
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryDrawer);
